import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	notFound: {
		display: 'block',
		marginTop: 30,
	},
});
